import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5868cc10")
const _hoisted_1 = { class: "login-panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-user-solid" }),
  /*#__PURE__*/_createTextVNode("帳號登錄")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-mobile-phone" }),
  /*#__PURE__*/_createTextVNode("手機登錄")
], -1)
const _hoisted_4 = { class: "account-control" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("記住密碼")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("忘記密碼")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 立即登錄 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginAccount = _resolveComponent("LoginAccount")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_LoginPhone = _resolveComponent("LoginPhone")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: _ctx.currentTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTab = $event)),
      stretch: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { name: "account" }, {
          label: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_LoginAccount, { ref: "accountRef" }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "phone" }, {
          label: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(_component_LoginPhone)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.isKeepPassword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isKeepPassword = $event)),
        onChange: _ctx.keepChange
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_link, { type: "primary" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "login-btn",
      onClick: _ctx.handleLoginClick
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}